import React, { Component } from 'react';
import { connect } from 'react-redux'
import {mapStateToProps,mapDispatchToProps,tLang}  from "Imports/web";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import queryString from 'query-string';
import i18n from 'i18next'
//import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import {$} from "Imports";
import {config,Init}  from "Imports/web";

import store from '../.././configureStore';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import { type } from 'jquery';

let axios = require('axios').default;

//let lang = 'zh-HK';

toast.configure({
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
});

    
//let temp = store;
// function aFunction(){
//     var newState =store.getState();
//     console.log('state changed',newState);
// }
 //store.subscribe(aFunction)

const helpers = {
    'reviseApiHeader' : function(self,axios) {
        axios.defaults.withCredentials = config.apiWithCredentials;
        axios.defaults.headers.common['Authorization'] = `Bearer ${self.props.user.token}`
        axios.defaults.headers.common['lang'] =  config.defaultLang;
        axios.defaults.headers.common['channel-id'] =  config.channelId;
        axios.defaults.headers.common['session-key'] = self.props.session.key;
     
        return axios;
    },
    'formError' : function (self,error_data,prefix = '') {
        Object.keys(error_data).map(function(key) {
            self.setState({[prefix + key+'_error']:error_data[key][0]});
            $('input[name="'+ prefix + key +'"]').removeClass('valid');
            $('input[name="'+ prefix + key +'"]').addClass('invalid');

            if (key == 'phone') {
                $('input[name="'+ prefix + key +'"]').closest('.input-field.phone').find('.helper-text').show();
            }

          
            return true;


        });

  
        if( $(".form-control.invalid").length != 0) {
            $('html, body').animate({
                scrollTop: $(".form-control.invalid").first().offset().top -150
            }, 500);
        }

       
    },
    'responseError': function(response) {
        if (!this.isEmpty(response.data.error)) {       
            this.showErrorMsg(response.data.error);
        }
    },
    'getLang' : function (){
       return helpers.getCurrentLang();
    },
    'buildLink' : function (url,lang) {
        var defaultLang = store.getState().settingReducer.defaultLang;

        if (typeof defaultLang == 'undefined') {
            defaultLang = config.defaultLang;
        }

        if (typeof lang == 'undefined') {
            lang = helpers.getCurrentLang();
        }

        if (typeof lang == 'undefined') {
            lang = defaultLang;
        }

        if (typeof lang == 'undefined') {
            lang = config.defaultLang;
        }

        //console.log('lang',lang);
        // config.langSupport.forEach(function(value, index, array){
        //     console.log(value);
        //     url = url.replace('/' + value +'/','');
        //     console.log(url);
        // });

        url = helpers.trimLangInLink(url);

        if (url.substring(0, 1) === '/') {
            url = url.substring(1);
        }
        //console.log('url',url);

        if (lang === defaultLang) {
            lang = '';
        }
        url = (lang === '' ? '/' + url : '/' + lang + '/' + url );
        //console.log('url',url);
 
        //url = lang + url;
        return url;
    },
    'apiLink' :function (url){  
        return config.apiEndPoint + url;
    }
    ,
    'trimLangInLink' : function (url){
      var supportLangs = store.getState().settingReducer.supportLangs;
      supportLangs.forEach(function(value, index, array){
            url = url.replace('/' + value.code +'/','');
      });

      var supportLangs = config.langSupport;

      supportLangs.forEach(function(value){
            url = url.replace('/' + value +'/','');
      });

      return url;
    },
    'removeParamInLink' : function (key) {
        // removeParams = ['page'];
        // const deleteRegex = new RegExp(removeParams.join('=|') + '=')

        // const params = window.location.search.slice(1).split('&')
        // let search = []
        // for (let i = 0; i < params.length; i++) if (deleteRegex.test(params[i]) === false) search.push(params[i])
      
        // window.history.replaceState({}, document.title, window.location.pathname + (search.length ? '?' + search.join('&') : '') + window.location.hash)

        // console.log('window.location.href',window.location.href );
        
        var pathName = helpers.trimLangInLink(window.location.pathname);

        if (window.location.search === '') {
            return pathName ;
        }

        var params = new Map(window.location.search.slice(1).split('&')
        .map(function(p) { return p.split(/=(.*)/) }))   
        var value = params.get(key)

        params.delete(key)

        //console.log('window.location.search',window.location.search);

        var search = Array.from(params.entries()).map(
            function(v){ return v[0]+'='+v[1] }).join('&')

        //console.log('search',search);
            
        var result = {search: search ? '?' + search : '', value: value};

        var finalUrl =  window.location.pathname + result.search;

        return finalUrl;
    },
    'redirect' : function(path) {
        if (path === '') {
            window.location = "";
        }else{
            window.location = path;
        }
        
    },
    'updateLanguage': function(lang) {
        var currentPath = window.location.href.replace(window.location.origin, "");
        var url = helpers.buildLink(currentPath,lang);
        helpers.redirect(url);
    },
    'reloadPage': function(needWait = 0) {

        if (needWait) {
            setTimeout(
            function() 
            {
                //do something special
                window.location.reload();
            }, 500);
        }else {
            window.location.reload();
        }
    },
    'preparePagination':function(self) {
      
        self.activePage ='';
        self.lastPage = 0;
        self.pageNum = 1;
        if (typeof self.props.location != 'undefined') {
            const value=queryString.parse(self.props.location.search);
            if (typeof value.page == 'undefined') {
                value.page = 1;
            }
            self.pageNum = value.page;
    
            self.originLink = helpers.removeParamInLink('page');
        }
    },
    'checkPaginationUpate':function(self) {

        console.log('checkPaginationUpate',sessionStorage.scrollPos);
        const value=queryString.parse(self.props.location.search);
        let pageNum = value.page;
        if (typeof pageNum != 'undefined' && self.activePage != '' ) {
            if (pageNum != self.activePage) {
                sessionStorage.scrollPos = 0  + ' '+ currentPath;
                window.location.reload();
                return false;
            }
        }

        var currentPath = window.location.href.replace(window.location.origin, "");
        
        if (typeof sessionStorage.scrollPos == 'undefined' ) {
            sessionStorage.scrollPos = 0 + currentPath;
        }

        var scrollPosValueAr = sessionStorage.scrollPos.split(' ');
        if (scrollPosValueAr[1] != currentPath) {
            sessionStorage.scrollPos = 0  + ' '+ currentPath;
            // window.location.reload();
            // return false;
        }
       
       
        $(window).scroll(function () {
        //set scroll position in session storage
        sessionStorage.scrollPos = $(window).scrollTop() + ' '+ currentPath;
        });
        var initScroll = function () {
            //return scroll position in session storage

            var scrollPosValueAr = sessionStorage.scrollPos.split(' ');

            $(window).scrollTop(scrollPosValueAr[0] || 0);

            setTimeout(function(){ sessionStorage.scrollPos = 0  + ' '+ currentPath;},200);
        };
        setTimeout(initScroll,200);
        
    },
    'showMsg' : function(message) {
        toast.success(<div className="show-msg-alert"><i class="fas fa-check-circle"></i> {message}</div>);
    },
    'showErrorMsg' : function(message) {
        toast.error(<div className="show-msg-alert"><i class="fas fa-exclamation-circle"></i> {message}</div>);  
    },
    'axiosCatch' : function(error,needRedirect = 0){
        console.log('error.response', error.message);

        if (typeof error.message != 'undefined')  {
            this.showErrorMsg(error.message);
        }

        if (typeof error.response != 'undefined')  {
            if (typeof error.response.status != 'undefined' && error.response.status === 404) {
                if (needRedirect)
                window.location = "/";
                
                return false;
            }
        }
    },
    'isEmpty': function(obj) {
        if (obj == null) {
            return true;
        }
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    },
    'buildHTitle' : function(title) {
        if (typeof title === 'undefined' || title === '') {
            return store.getState().settingReducer.metaTitle + " | "+ config.shopName;
        } else {
            return title + " | " + config.shopName;
        }
    },
    'getStoreName': function() {
        return store.getState().settingReducer.channelName;
    },
    'getStoreLogo': function() {

        if (typeof title === store.getState().settingReducer.channelLogo == 'undefined') {
            return '';
        }

        return config.imagePathPrefix + store.getState().settingReducer.channelLogo;
    },
    'getFavicon': function() {

        if (typeof title === store.getState().settingReducer.channelFavicon == 'undefined') {
            return '';
        }

        return config.imagePathPrefix + store.getState().settingReducer.channelFavicon;
    },
    'getMetaDesc': function() {
        return store.getState().settingReducer.metaDesc;
    },
    'getUser': function() {   
        return store.getState().userReducer;
    },
    'getCartItemCount': function() {   
        return store.getState().cartReducer.cartItemCount;
    },
    'intiPhoneInput': function(inputId) {
        var input = document.querySelector(inputId);
        var iti =  intlTelInput(input, {
            separateDialCode: true,
            submitCountryCode: true,
            hiddenInput: "user_phone_intlTelNumber",
            preferredCountries: ['hk'],
            initialCountry: 'auto',
            geoIpLookup: function(callback) {
            var countryCode = '';
            if (countryCode == '') {
                $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : "hk";
                callback(countryCode);
                    iti.setCountry(countryCode);
                });
            }
            },
            //utilsScript: "intl-tel-input/build/js/utils.js?1549804213570",
            // any initialisation options go here
        });

        return iti;
    },
    'initConstruct' :function(self) {
        axios = helpers.reviseApiHeader(self,axios);
        helpers.preparePagination(self);
        self.t = (value) => {
            if (self.props.tReady === true) {
                return self.props.t(value);
            }
        };
    },
    'init' : function (self) { 
    },
    'checkLoginRedirect' : function (self,needWait=true,redirectAfterLoginPath = '') {
        var waitTime = 0;
        if (needWait) {
            var waitTime = 400;
        }
        window.setTimeout(
            function(){
             if (self.props.user.id == null) {
                 if (redirectAfterLoginPath != '') {
                    self.props.setRedirectAfterLogin(redirectAfterLoginPath);
                 }

                 self.props.saveSuccessMessage(tLang('please_login'));
                 var link = helpers.buildLink("/login");

                 if (needWait) {
                    window.setTimeout(
                        function(){
                            window.location = link;
                            self.props.history.replace(link);
                        },waitTime);
                }
                 //history.push('login');
                 return true;
             }
            }
         , waitTime);
    },
    'isMobile':function ()
    {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },
    'checkSystemSupportLangs' :function($lang)
    {
        var result = false;
        var supportLangs = store.getState().settingReducer.supportLangs;
        supportLangs.forEach(function(value, index, array){
            if ($lang == value.code) {
                result = true;
            }
        });

        return result;
    },
    'getCurrentLang' : function()
    {
        return store.getState().userReducer.lang;
    },
    'getImageSrcset' : function(path)
    {
        if (!this.isEmpty(path)) {
            var smallPath = path;
            var extension = path.split('.').pop();
            return smallPath.replace('.'+extension, '_s'+'.'+extension) + ' 480w,' + path + ' 1080w';
        } else {
            return path;
        }    
    },
    'getImageSrcsetWebp' : function(path)
    {
        if (!this.isEmpty(path)) {
            var smallPath = path;
            var extension = path.split('.').pop();
            return smallPath.replace('.'+extension, '_s'+'.'+ 'webp');
        } else {
            return path;
        }    
    },
    'displayPrice' : function(item)
    {
        //return <span className="discount-price">{item.price.original_price > 0 ? item.price.original_price_format : '' } </span><b>{item.price.price_format}</b>;
    }

}

export default helpers;
//export default connect(mapStateToProps, null)(helpers);
